
import { Component, Vue } from 'vue-property-decorator';

@Component({ name: 'ImageCarousel', components: {} })
export default class ImageCarousel extends Vue {
  get photos(): string[] {
    return [
      '/img/fotos/gezicht.jpg',
      '/img/fotos/nagels.jpg',
      '/img/fotos/shelf.jpg',
      '/img/fotos/space.jpg',
    ];
  }

  get height(): string {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return '250px';
      case 'sm':
      case 'md':
      case 'lg':
      case 'xl':
        return '450px';
      default:
        return '450px';
    }
  }
}
